// libs
import { matchPath } from 'react-router'
// types
import { CanViewType, FieldType, SecurityProfileReviewPermission } from 'types/graphql'

export const GENERAL_FUNCTIONS = [
  { name: 'home', label: 'Home', type: FieldType.Switch },
  { name: 'planRegister', label: 'Plan Register', type: FieldType.Switch },
  { name: 'createPlan', label: 'Create Plan', type: FieldType.Switch },
  { name: 'kpiRegister', label: 'Indicator Register', type: FieldType.Switch },
  { name: 'createKPI', label: 'Create Indicator', type: FieldType.Switch },
  { name: 'actionRegister', label: 'Action Register', type: FieldType.Switch },
  { name: 'createAction', label: 'Create Action', type: FieldType.Switch },
  { name: 'objectiveRegister', label: 'Objective Register', type: FieldType.Switch },
  { name: 'settings', label: 'Settings', type: FieldType.Switch },
  { name: 'reporting', label: 'the Data Hub', type: FieldType.Switch },
  { name: 'manageRiskTemplates', label: 'Manage Templates', type: FieldType.Switch },
  { name: 'manageDashboards', label: 'Manage Dashboards', type: FieldType.Switch },
  { name: 'globalSearch', label: 'Enable Global Search', type: FieldType.Switch },
  { name: 'viewOrganizationLevelData', label: 'View Organization Level Data', type: FieldType.Switch }
]

export const PLAN_FUNCTIONS = [
  { name: 'planModifyPlan', label: 'Modify Plan', type: FieldType.Switch },
  { name: 'planDeletePlan', label: 'Delete Plan', type: FieldType.Switch },
  { name: 'planCreateScheduledReview', label: 'Create Scheduled Review', type: FieldType.Switch },
  { name: 'planModifyScheduledReview', label: 'Modify Scheduled Review', type: FieldType.Switch },
  { name: 'planDeleteScheduledReview', label: 'Delete Scheduled Review', type: FieldType.Switch },
  { name: 'planViewInProgressReview', label: 'View IN-PROGRESS Review', type: FieldType.PickList },
  { name: 'planViewCompletedReview', label: 'View COMPLETED Review', type: FieldType.PickList },
  { name: 'planLinkObjects', label: 'Link Objects', type: FieldType.Switch },
  { name: 'planAddItemsFromParentPlan', label: 'Add Items from Parent Plan', type: FieldType.Switch },
  { name: 'planAddObjective', label: 'Add Objective', type: FieldType.Switch },
  { name: 'planAddAction', label: 'Add Action', type: FieldType.Switch },
  { name: 'planAddKPI', label: 'Add Indicator', type: FieldType.Switch },
  { name: 'planSetPlanSecurity', label: 'Set Plan Security', type: FieldType.Switch },
  { name: 'planSetUserPlanSecurity', label: 'Set User Plan Security', type: FieldType.Switch },
  { name: 'planCreateSubPlan', label: 'Create Sub Plan', type: FieldType.Switch }
]

export const OBJECTIVE_FUNCTIONS = [
  { name: 'objectiveModifyObjective', label: 'Modify Objective', type: FieldType.Switch },
  { name: 'objectiveDeleteObjective', label: 'Delete Objective', type: FieldType.Switch },
  { name: 'objectiveArchiveObjective', label: 'Archive Objective', type: FieldType.Switch },
  { name: 'objectiveCreateScheduledReview', label: 'Create Scheduled Review', type: FieldType.Switch },
  { name: 'objectiveModifyScheduledReview', label: 'Modify Scheduled Review', type: FieldType.Switch },
  { name: 'objectiveDeleteScheduledReview', label: 'Delete Scheduled Review', type: FieldType.Switch },
  { name: 'objectiveViewInProgressReview', label: 'View IN-PROGRESS Review', type: FieldType.PickList },
  { name: 'objectiveViewCompletedReview', label: 'View COMPLETED Review', type: FieldType.PickList },
  { name: 'objectiveLinkObjects', label: 'Link Objects', type: FieldType.Switch },
  { name: 'objectiveCreateResource', label: 'Create Resource', type: FieldType.Switch },
  { name: 'objectiveModifyResource', label: 'Modify Resource', type: FieldType.Switch },
  { name: 'objectiveDeleteResource', label: 'Delete Resource', type: FieldType.Switch },
  { name: 'objectiveAddObjective', label: 'Add Objective', type: FieldType.Switch },
  { name: 'objectiveAddAction', label: 'Add Action', type: FieldType.Switch },
  { name: 'objectiveAddKPI', label: 'Add Indicator', type: FieldType.Switch },
  { name: 'objectiveSetUserObjectiveSecurity', label: 'Set User Objective Security', type: FieldType.Switch }
]

export const ACTION_FUNCTIONS = [
  { name: 'actionModifyAction', label: 'Modify Action', type: FieldType.Switch },
  { name: 'actionDeleteAction', label: 'Delete Action', type: FieldType.Switch },
  { name: 'actionArchiveAction', label: 'Archive Action', type: FieldType.Switch },
  { name: 'actionCreateScheduledReview', label: 'Create Scheduled Review', type: FieldType.Switch },
  { name: 'actionModifyScheduledReview', label: 'Modify Scheduled Review', type: FieldType.Switch },
  { name: 'actionDeleteScheduledReview', label: 'Delete Scheduled Review', type: FieldType.Switch },
  { name: 'actionViewInProgressReview', label: 'View IN-PROGRESS Review', type: FieldType.PickList },
  { name: 'actionViewCompletedReview', label: 'View COMPLETED Review', type: FieldType.PickList },
  { name: 'actionLinkObjects', label: 'Link Objects', type: FieldType.Switch },
  { name: 'actionCreateResource', label: 'Create Resource', type: FieldType.Switch },
  { name: 'actionModifyResource', label: 'Modify Resource', type: FieldType.Switch },
  { name: 'actionDeleteResource', label: 'Delete Resource', type: FieldType.Switch },
  { name: 'actionAddObjective', label: 'Add Objective', type: FieldType.Switch },
  { name: 'actionAddAction', label: 'Add Action', type: FieldType.Switch },
  { name: 'actionAddKPI', label: 'Add Indicator', type: FieldType.Switch },
  { name: 'actionSetUserActionSecurity', label: 'Set User Action Security', type: FieldType.Switch }
]

export const KPI_FUNCTIONS = [
  { name: 'kpiModifyKPI', label: 'Modify Indicator', type: FieldType.Switch },
  { name: 'kpiDeleteKPI', label: 'Delete Indicator', type: FieldType.Switch },
  { name: 'kpiArchiveKPI', label: 'Archive Indicator', type: FieldType.Switch },
  { name: 'kpiCreateScheduledReview', label: 'Create Scheduled Review', type: FieldType.Switch },
  { name: 'kpiModifyScheduledReview', label: 'Modify Scheduled Review', type: FieldType.Switch },
  { name: 'kpiDeleteScheduledReview', label: 'Delete Scheduled Review', type: FieldType.Switch },
  { name: 'kpiViewInProgressReview', label: 'View IN-PROGRESS Review', type: FieldType.PickList },
  { name: 'kpiViewCompletedReview', label: 'View COMPLETED Review', type: FieldType.PickList },
  { name: 'kpiLinkObjects', label: 'Link Objects', type: FieldType.Switch },
  { name: 'kpiAddKPIResult', label: 'Add Indicator Result', type: FieldType.Switch },
  { name: 'kpiModifyKPIResult', label: 'Modify Indicator Result', type: FieldType.Switch },
  { name: 'kpiDeleteKPIResult', label: 'Delete Indicator Result', type: FieldType.Switch },
  { name: 'kpiAddObjective', label: 'Add Objective', type: FieldType.Switch },
  { name: 'kpiAddAction', label: 'Add Action', type: FieldType.Switch },
  { name: 'kpiAddKPI', label: 'Add Indicator', type: FieldType.Switch },
  { name: 'kpiModifyUserKPISecurity', label: 'Modify User Indicator Security', type: FieldType.Switch }
]

export const FORM_FUNCTIONS = [
  { name: 'riskCreate', label: 'Create Form', type: FieldType.Switch },
  { name: 'riskModify', label: 'Modify Form', type: FieldType.Switch },
  { name: 'riskDelete', label: 'Delete Form', type: FieldType.Switch },
  { name: 'riskSetSecurity', label: 'Set Form Security', type: FieldType.Switch },
  { name: 'riskSetUserRiskSecurity', label: 'Set User Form Security', type: FieldType.Switch },
  { name: 'riskViewRelatedRisks', label: 'View Related Form', type: FieldType.Switch },
  { name: 'manageDisabledRisks', label: 'Modify Locked Form', type: FieldType.Switch },
  { name: 'scheduleRisks', label: 'Schedule Forms', type: FieldType.Switch },
  { name: 'editReadOnlyFields', label: 'Modify Read-Only Fields', type: FieldType.Switch },
  { name: 'modifyOwnedGroupedRisks', label: 'Modify Own Grouped Forms', type: FieldType.Switch },
  { name: 'viewLinkedParentRisk', label: 'View Linked Parent Risk', type: FieldType.Switch },
  { name: 'riskArchive', label: 'Archive Forms', type: FieldType.Switch }
]

export const ADMINISTRATION_FUNCTIONS = [
  { name: 'adminViewPrivatePlans', label: 'View Private Plans', type: FieldType.Switch },
  { name: 'adminViewPrivateRisks', label: 'View Private Forms', type: FieldType.Switch },
  { name: 'adminLockPlans', label: 'Lock Plans', type: FieldType.Switch }
]

export const DATA_HUB_FUNCTIONS = [
  { name: 'reportingCreate', label: 'Create Report', type: FieldType.Switch },
  { name: 'reportingEdit', label: 'Edit Report', type: FieldType.Switch },
  { name: 'reportingClone', label: 'Clone Report', type: FieldType.Switch },
  { name: 'reportingDelete', label: 'Delete Report', type: FieldType.Switch },
  { name: 'reportingRefresh', label: 'Refresh Datasets', type: FieldType.Switch },
  { name: 'manageReports', label: 'Manage Reports', type: FieldType.Switch }
]

export const AI_FUNCTIONS = [
  { name: 'aiViewUsage', label: 'View AI Usage', type: FieldType.Switch },
  { name: 'aiManageSettings', label: 'Enable Manage AI Settings', type: FieldType.Switch },
  { name: 'aiEnableUsage', label: 'Enable AI', type: FieldType.Switch }
]

export const PROFILE_SELECT_OPTIONS = [
  { label: 'None', value: SecurityProfileReviewPermission.None },
  { label: 'Own', value: SecurityProfileReviewPermission.Own },
  { label: 'All', value: SecurityProfileReviewPermission.All }
]

export const VIEW_OBJECTS = {
  BUSINESS_ACTIVITY: 'BUSINESS_ACTIVITY',
  BUSINESS_PROCESS: 'BUSINESS_PROCESS',
  BUSINESS_UNIT: 'BUSINESS_UNIT',
  PLAN_TYPE: 'PLAN_TYPE'
}

export const VIEW_OBJECT_TYPE_OPTIONS = [
  { label: 'Business Activity', value: VIEW_OBJECTS.BUSINESS_ACTIVITY },
  { label: 'Business Process', value: VIEW_OBJECTS.BUSINESS_PROCESS },
  { label: 'Business Unit', value: VIEW_OBJECTS.BUSINESS_UNIT },
  { label: 'Plan Type', value: VIEW_OBJECTS.PLAN_TYPE }
]

export const CAN_VIEW_OBJECTS_OPTIONS = [
  { label: 'Plan', value: CanViewType.Plan },
  { label: 'Indicators (independent)', value: CanViewType.IndependentKpi },
  { label: 'Actions (independent)', value: CanViewType.IndependentAction }
]

export const SECURITY_PROFILE_INITIAL_VALUES = {
  active: true,
  home: false,
  planRegister: false,
  createPlan: false,
  kpiRegister: false,
  createKPI: false,
  globalSearch: false,
  actionRegister: false,
  actionLinkObjects: false,
  createAction: false,
  objectiveRegister: false,
  reporting: false,
  reportingClone: false,
  reportingCreate: false,
  reportingDelete: false,
  reportingEdit: false,
  reportingRefresh: false,
  manageReports: false,
  settings: false,
  planModifyPlan: false,
  planDeletePlan: false,
  planCreateScheduledReview: false,
  planModifyScheduledReview: false,
  planDeleteScheduledReview: false,
  planViewInProgressReview: PROFILE_SELECT_OPTIONS[0],
  planViewCompletedReview: PROFILE_SELECT_OPTIONS[0],
  planLinkObjects: false,
  planAddItemsFromParentPlan: false,
  planAddObjective: false,
  planAddAction: false,
  planAddKPI: false,
  planSetPlanSecurity: false,
  planSetUserPlanSecurity: false,
  planCreateSubPlan: false,
  objectiveModifyObjective: false,
  objectiveDeleteObjective: false,
  objectiveArchiveObjective: false,
  objectiveCreateScheduledReview: false,
  objectiveModifyScheduledReview: false,
  objectiveDeleteScheduledReview: false,
  objectiveViewInProgressReview: PROFILE_SELECT_OPTIONS[0],
  objectiveViewCompletedReview: PROFILE_SELECT_OPTIONS[0],
  objectiveCreateResource: false,
  objectiveModifyResource: false,
  objectiveDeleteResource: false,
  objectiveAddObjective: false,
  objectiveAddAction: false,
  objectiveAddKPI: false,
  objectiveSetUserObjectiveSecurity: false,
  objectiveLinkObjects: false,
  actionModifyAction: false,
  actionDeleteAction: false,
  actionArchiveAction: false,
  actionCreateScheduledReview: false,
  actionModifyScheduledReview: false,
  actionDeleteScheduledReview: false,
  actionViewInProgressReview: PROFILE_SELECT_OPTIONS[0],
  actionViewCompletedReview: PROFILE_SELECT_OPTIONS[0],
  actionCreateResource: false,
  actionModifyResource: false,
  actionDeleteResource: false,
  actionAddObjective: false,
  actionAddAction: false,
  actionAddKPI: false,
  actionSetUserActionSecurity: false,
  kpiModifyKPI: false,
  kpiDeleteKPI: false,
  kpiArchiveKPI: false,
  kpiCreateScheduledReview: false,
  kpiModifyScheduledReview: false,
  kpiDeleteScheduledReview: false,
  kpiViewInProgressReview: PROFILE_SELECT_OPTIONS[0],
  kpiViewCompletedReview: PROFILE_SELECT_OPTIONS[0],
  kpiAddKPIResult: false,
  kpiModifyKPIResult: false,
  kpiDeleteKPIResult: false,
  kpiAddObjective: false,
  kpiAddAction: false,
  kpiAddKPI: false,
  kpiModifyUserKPISecurity: false,
  kpiLinkObjects: false,
  adminViewPrivatePlans: false,
  adminViewPrivateRisks: false,
  adminLockPlans: false,
  manageRiskTemplates: false,
  manageDashboards: false,
  manageDisabledRisks: false,
  riskCreate: false,
  riskModify: false,
  riskDelete: false,
  riskSetSecurity: false,
  riskSetUserRiskSecurity: false,
  riskViewRelatedRisks: false,
  editReadOnlyFields: false,
  scheduleRisks: false,
  modifyOwnedGroupedRisks: false,
  viewLinkedParentRisk: false,
  riskArchive: false,
  viewOrganizationLevelData: false,
  aiViewUsage: false,
  aiManageSettings: false,
  aiEnableUsage: false
}

// as const — without it, these properties widen to `string`, and every type
// derived from FORM_SELECT_SECURITY_OPTIONS's `value` (e.g. in tests/helpers)
// silently collapses to `string` too, losing any real autocomplete/typo
// protection despite looking like a proper literal union.
export const FORM_SELECT_SECURITY_VALUES = {
  USER_CREATING_RECORD: 'USER_CREATING_RECORD',
  POSITION_CREATING_RECORD: 'POSITION_CREATING_RECORD',
  REPORTS_TO_USER: 'REPORTS_TO_USER',
  REPORTS_TO_POSITION: 'REPORTS_TO_POSITION'
} as const

export const FORM_SELECT_SECURITY_OPTIONS = [
  { label: 'User creating record', value: FORM_SELECT_SECURITY_VALUES.USER_CREATING_RECORD },
  { label: 'Position creating record', value: FORM_SELECT_SECURITY_VALUES.POSITION_CREATING_RECORD },
  { label: 'Reports to user of user creating record', value: FORM_SELECT_SECURITY_VALUES.REPORTS_TO_USER },
  { label: 'Reports to position of user creating record', value: FORM_SELECT_SECURITY_VALUES.REPORTS_TO_POSITION }
]


const PUBLIC_PAGE_PATTERNS = [
  '/',
  '/login',
  '/login/verify-2fa',
  '/azuresso',
  '/reset-password',
  '/reset-password/confirm',
  '/public/form/:id',
  '/public/form/create/:id'
]

export const isPublicPage = (pathname: string): boolean =>
  PUBLIC_PAGE_PATTERNS.some((pattern) => matchPath(pattern, pathname) !== null)

export const PUBLIC_PERMISSIONS = {
  riskCreate: true,
  riskModify: true,
  riskDelete: false,
  riskSetSecurity: false,
  riskSetUserRiskSecurity: false,
  riskViewRelatedRisks: false,
  editReadOnlyFields: false,
  modifyOwnedGroupedRisks: false,
  scheduleRisks: false
}

export enum AVAILABLE_TO {
  ALL = 'ALL',
  MANAGERS = 'ALL_MANAGERS'
}
